export type Progress = 'no' | 'partial' | 'yes';
export const PROGRESS_LABELS: Record<Progress, string> = { no: 'Not started', partial: 'Partially completed', yes: 'Completed' };
export type EvidenceRequirement = 'required' | 'optional' | 'unset';
export type TaskQuestion = { question_text: string; sub_criteria?: string[] | null; task_evidence_requirements?: EvidenceRequirement[] | null };

/** Positions are scoped to the assessment's immutable pinned question. */
export function assessmentTasks(question: TaskQuestion): string[] {
  return question.sub_criteria?.length ? question.sub_criteria : [question.question_text];
}

/** Absence or mismatched metadata never creates an evidence obligation. */
export function taskEvidenceRequirements(question: TaskQuestion): EvidenceRequirement[] {
  const tasks = assessmentTasks(question);
  const choices = question.task_evidence_requirements;
  if (!Array.isArray(choices) || choices.length !== tasks.length) return tasks.map(() => 'unset');
  return choices.map(value => value === 'required' || value === 'optional' ? value : 'unset');
}

export function taskProgressAnswer(question: TaskQuestion, tasks: (Progress | null)[]) {
  const explicit = tasks.length === assessmentTasks(question).length && tasks.every(value => value !== null);
  const answer: Progress = explicit && tasks.every(value => value === 'yes') ? 'yes'
    : tasks.some(value => value === 'yes' || value === 'partial') ? 'partial' : 'no';
  return {
    model: 'task_progress_v1' as const, tasks, answer, explicit,
    checked: [...new Set((question.sub_criteria ?? []).filter((_, index) => tasks[index] === 'yes'))],
  };
}
